export const PREDEFINED_TRANSLATION_KEYS = [
    "name",
    "status",
    "active",
    "inactive",
    "error",
    "an-unexpected-error-occurred",
    "prefix",
    "supplier",

    "apx-marketplaces-title",
    "apx-marketplaces-connected-suppliers-count",
    "apx-marketplaces-no-marketplaces",
    "apx-marketplaces-connected-suppliers",
    "apx-marketplaces-full-export-date",
    "apx-marketplaces-update-export-date",
    "apx-marketplaces-export-version",
    "apx-marketplaces-no-connected-suppliers",
];
